import { IClientBonCommandeModel, IClientBonLivraisonModel } from "@common-models/*"
import React, { useEffect, useRef, useState } from "react"
import { toAbsoluteUrl } from "@common-metronic/helpers"
import MyModal from "@common-utils/MyModal"
import { toast } from "react-toastify"
import { deleteBonLivraisonRequest } from "../core/_requests"
import { usePtfDetailsPeriodesBonsCommandeBonsLivraisonContext } from "./_PtfDetailsPeriodesBonsCommandeBonsLivraison"
import { useQueryClient } from "react-query"
import { IGetPeriodesBonsCommandeBonsLivraisonResponseModel } from "../core/_models"
import useSwal from "@common-hooks/useSwal"
import PtfPeriodeBonCommandeBonLivraisonEditForm from "../actions/_PtfPeriodeBonCommandeBonLivraisonEditForm"
import PtfPeriodeBonCommandeLivrableEditForm from "../actions/_PtfPeriodeBonCommandeLivrableEditForm"
import MyGoogleDriveFileViewerInModal from "../../../../components/MyDocumentViewer/MyGoogleDriveFileViewerInModal"
import MyTooltip from "@common-utils/MyTooltip"
import { useAuth } from "../../../../AppContext"
import { CONST_USER_ROLE_COMPTABLE, CONST_USER_ROLE_DAF, CONST_USER_ROLE_DG, CONST_USER_ROLE_IT, CONST_USER_ROLE_PRESIDENT, CONST_USER_ROLE_SUPER_ADMIN } from "@common-constants/*"

const PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsLivraison = ({ bonCommande, ptf_type }: IPtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommandePropsModel) => {
     const context = usePtfDetailsPeriodesBonsCommandeBonsLivraisonContext()
     const queryClient = useQueryClient()
     const { swal } = useSwal()
     const { currentUser } = useAuth()

     // Carousel Logic State
     const scrollContainerRef = useRef<HTMLDivElement>(null)
     const [canScrollLeft, setCanScrollLeft] = useState(false)
     const [canScrollRight, setCanScrollRight] = useState(false)

     const [currentBonLivraisonInModal, setCurrentBonLivraisonInModal] = useState<{
          bl: IClientBonLivraisonModel
          index: number
          loading: boolean
     }>()
     const [editBonLivraisonInModal, setEditBonLivraisonInModal] = useState<IClientBonLivraisonModel>()

     // --- CAROUSEL LOGIC START ---
     const checkScrollButtons = () => {
          if (scrollContainerRef.current) {
               const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current
               setCanScrollLeft(scrollLeft > 0)
               // On ajoute une marge de 2px pour éviter les arrondis imprécis du navigateur
               setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 2)
          }
     }

     useEffect(() => {
          const container = scrollContainerRef.current
          if (!container) return

          // Détecte les changements de taille du conteneur ou de ses enfants
          const resizeObserver = new ResizeObserver(() => {
               checkScrollButtons()
          })

          resizeObserver.observe(container)

          // Initial check
          checkScrollButtons()

          // Re-vérifier après un court délai pour laisser les styles Metronic s'appliquer (ex: transitions)
          const timeoutId = setTimeout(checkScrollButtons, 100)

          return () => {
               resizeObserver.disconnect()
               clearTimeout(timeoutId)
          }
     }, [bonCommande.clientBonLivraisons]) // On garde la dépendance sur les données

     const scroll = (direction: "left" | "right") => {
          if (scrollContainerRef.current) {
               const scrollAmount = 300 // Approx width of one card + gap
               const newScrollPosition = direction === "left" ? scrollContainerRef.current.scrollLeft - scrollAmount : scrollContainerRef.current.scrollLeft + scrollAmount

               scrollContainerRef.current.scrollTo({
                    left: newScrollPosition,
                    behavior: "smooth",
               })
          }
     }

     // --- CAROUSEL LOGIC END ---

     function handleRemoveBonLivraison(id: number) {
          swal.fire({
               icon: "warning",
               text: `Voulez-vous vraiment supprimer ${ptf_type === "TYPE_FORFAIT" ? "le livrable" : "le bon de livraison"} ?`,
               showCancelButton: true,
               confirmButtonText: "Oui",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    return deleteBonLivraisonRequest(id)
                         .then(() => {
                              queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
                                   context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
                                   (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                                        if (prev?.data) {
                                             prev.data.map(item => {
                                                  item.clientPropalPeriodes?.map(item_ => {
                                                       item_.clientBonCommandes?.map(item__ => {
                                                            item__.clientBonLivraisons?.map(item___ => {
                                                                 if (item___.id === id) {
                                                                      item__.clientBonLivraisons = item__.clientBonLivraisons?.filter(item____ => item____.id !== id)
                                                                 }
                                                            })
                                                            return item__
                                                       })
                                                  })
                                             })
                                             return prev
                                        }
                                        return prev
                                   }
                              )
                              toast.info(ptf_type === "TYPE_FORFAIT" ? "Le livrable a bien été supprimé" : "Le bon de commande a bien été supprimé")
                         })
                         .catch(e => {
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !swal.isLoading(),
          }).then()
     }

     function handleSubmitEditBonCommandeCallback(val: IClientBonCommandeModel) {
          queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
               context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
               (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                    if (prev?.data) {
                         prev.data.map(item => {
                              item.clientPropalPeriodes?.map(item_ => {
                                   item_.clientBonCommandes!.map(item__ => {
                                        item__.clientBonLivraisons!.map((item___, index___) => {
                                             if (item___.id === editBonLivraisonInModal?.id) {
                                                  item__.clientBonLivraisons![index___] = {
                                                       ...item__.clientBonLivraisons![index___],
                                                       ...val,
                                                  }
                                             }
                                        })
                                        return item__
                                   })
                              })
                         })
                    }
                    return prev
               }
          )
          setEditBonLivraisonInModal(undefined)
     }

     return (
          <div className="position-relative w-100 hover-show-arrows">
               {/* Left Arrow Button */}
               {canScrollLeft && (
                    <button
                         type="button"
                         className="btn btn-icon btn-light-primary btn-sm shadow-sm rounded-circle position-absolute top-50 start-0 translate-middle-y z-index-1 carousel-nav-btn ms-n3"
                         onClick={() => scroll("left")}
                         style={{ zIndex: 10 }}
                    >
                         <i className="fas fa-chevron-left fs-4" />
                    </button>
               )}

               {/* Right Arrow Button */}
               {canScrollRight && (
                    <button
                         type="button"
                         className="btn btn-icon btn-light-primary btn-sm shadow-sm rounded-circle position-absolute top-50 end-0 translate-middle-y z-index-1 carousel-nav-btn me-n3"
                         onClick={() => scroll("right")}
                         style={{ zIndex: 10 }}
                    >
                         <i className="fas fa-chevron-right fs-4" />
                    </button>
               )}

               {/* Scroll Container */}
               <div className="d-flex flex-row flex-nowrap overflow-auto gap-5 pb-3 hide-scrollbar" ref={scrollContainerRef} onScroll={checkScrollButtons}>
                    {bonCommande.clientBonLivraisons?.map((bl, index) => (
                         <div className="flex-shrink-0" style={{ width: "280px" }} key={index}>
                              <div className="card h-100 card-bordered border-dashed hover-elevate-up shadow-sm">
                                   <div className="card-body p-4 d-flex flex-column">
                                        {/* Header */}
                                        <div className="d-flex justify-content-between align-items-start mb-3">
                                             <div className="d-flex align-items-center">
                                                  <div className="symbol symbol-35px me-3">
                                                       <span className="symbol-label bg-light-warning text-warning fw-bold fs-6">{index + 1}</span>
                                                  </div>
                                                  <div>
                                                       <div className="fs-6 fw-bolder text-gray-800 line-clamp-1" title={bl.livrableIntitule}>
                                                            {ptf_type === "TYPE_FORFAIT" ? bl.livrableIntitule || `Livrable n°${index + 1}` : `BL n°${index + 1}`}
                                                       </div>
                                                       <div className="fs-8 fw-bold text-gray-400">Ref: {bl.id}</div>
                                                  </div>
                                             </div>

                                             {/* Status Badge */}
                                             <span className="badge badge-light-primary fw-bolder px-2 py-1 fs-8">{bl.etatLabel}</span>
                                        </div>

                                        {/* Content Grid */}
                                        <div className="mb-4 bg-light bg-opacity-50 rounded p-3 border border-gray-200 border-dashed">
                                             {ptf_type === "TYPE_FORFAIT" && (
                                                  <div className="d-flex flex-column gap-2 mb-3">
                                                       <div className="d-flex justify-content-between">
                                                            <span className="text-gray-500 fs-7 fw-semibold">Lot</span>
                                                            <span className="fw-bold text-gray-800 fs-7">{bl.livrableLot || "-"}</span>
                                                       </div>
                                                       <div className="d-flex justify-content-between">
                                                            <span className="text-gray-500 fs-7 fw-semibold">Livraison</span>
                                                            <span className="fw-bold text-gray-800 fs-7">
                                                                 {bl.dateDebut ? bl.dateDebut.format("DD MMM YYYY") : <span className="text-muted">-</span>}
                                                            </span>
                                                       </div>
                                                  </div>
                                             )}
                                             {ptf_type === "TYPE_ASSISTANCE_TECHNIQUE" && (
                                                  <div className="d-flex justify-content-between mb-3">
                                                       <span className="text-gray-500 fs-7 fw-semibold">Période</span>
                                                       <span className="fw-bold text-gray-800 fs-7 text-end">
                                                            {bl.dateDebut?.format("D MMM")} - {bl.dateFin?.format("D MMM YYYY")}
                                                       </span>
                                                  </div>
                                             )}
                                             {/* DESIGN CHANGE: Separator and Price Handling */}
                                             <div className="separator separator-dashed border-gray-300 my-2"></div>
                                             <div className="d-flex justify-content-between align-items-center mt-2">
                                                  <span className="text-gray-600 fs-7 fw-bold">Montant HT</span>

                                                  {typeof bl.montantHt === "number" ? (
                                                       <div className="d-flex align-items-center">
                                                            <span className="fs-6 fw-bolder text-gray-900 me-1">
                                                                 {bl.montantHt.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </span>
                                                            <span className="fs-7 fw-bold text-gray-500">€</span>
                                                       </div>
                                                  ) : (
                                                       // If null, show a badge instead of empty text
                                                       <span className="badge badge-light-secondary text-gray-500 fw-bold fs-8 px-2">Non chiffré</span>
                                                  )}
                                             </div>

                                             {(currentUser?.roles?.includes(CONST_USER_ROLE_SUPER_ADMIN) ||
                                                  currentUser?.roles?.includes(CONST_USER_ROLE_IT) ||
                                                  currentUser?.roles?.includes(CONST_USER_ROLE_PRESIDENT) ||
                                                  currentUser?.roles?.includes(CONST_USER_ROLE_DG) ||
                                                  currentUser?.roles?.includes(CONST_USER_ROLE_DAF) ||
                                                  currentUser?.roles?.includes(CONST_USER_ROLE_COMPTABLE)) && (
                                                  <div className="d-flex justify-content-between align-items-center mt-2">
                                                       <span className="text-gray-600 fs-7 fw-bold">Montant TVA</span>

                                                       {typeof bl.montantTva === "number" ? (
                                                            <div className="d-flex align-items-center">
                                                                 <span className="fs-6 fw-bolder text-gray-900 me-1">
                                                                      {bl.montantTva.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                 </span>
                                                                 <span className="fs-7 fw-bold text-gray-500">€</span>
                                                            </div>
                                                       ) : (
                                                            // If null, show a badge instead of empty text
                                                            <span className="badge badge-light-secondary text-gray-500 fw-bold fs-8 px-2">Non chiffré</span>
                                                       )}
                                                  </div>
                                             )}
                                        </div>

                                        {/* Footer / Actions */}
                                        <div className="mt-auto d-flex align-items-center justify-content-between pt-2">
                                             {bl.googleDriveID ? (
                                                  <div
                                                       className="d-flex align-items-center cursor-pointer text-hover-primary transition-all"
                                                       onClick={() => setCurrentBonLivraisonInModal({ bl, loading: true, index })}
                                                  >
                                                       <span className="symbol symbol-20px me-2">
                                                            <img src={toAbsoluteUrl("/media/svg/files/pdf.svg")} alt="pdf" />
                                                       </span>
                                                       <span className="fs-8 fw-bold text-gray-600">Document</span>
                                                  </div>
                                             ) : (
                                                  <MyTooltip title="Aucun document lié">
                                                       <div className="d-flex align-items-center text-gray-400">
                                                            <i className="fas fa-exclamation-circle me-1 fs-8 text-gray-400"></i>
                                                            <span className="fs-8">N/A</span>
                                                       </div>
                                                  </MyTooltip>
                                             )}

                                             <div className="d-flex gap-1">
                                                  <MyTooltip title="Modifier">
                                                       <button
                                                            className="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-25px h-25px"
                                                            onClick={() => setEditBonLivraisonInModal(bl)}
                                                       >
                                                            <i className="fas fa-edit fs-6" />
                                                       </button>
                                                  </MyTooltip>
                                                  <MyTooltip title="Supprimer">
                                                       <button
                                                            className="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-danger w-25px h-25px"
                                                            onClick={() => handleRemoveBonLivraison(bl.id as number)}
                                                       >
                                                            <i className="fas fa-trash fs-6" />
                                                       </button>
                                                  </MyTooltip>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    ))}
               </div>

               {/* Modals */}
               {currentBonLivraisonInModal && (
                    <MyGoogleDriveFileViewerInModal
                         googleDriveID={currentBonLivraisonInModal.bl.googleDriveID as string}
                         googleDriveMimetype={currentBonLivraisonInModal.bl.googleDriveMimeType as string}
                         modalTitle={
                              <>
                                   {currentBonLivraisonInModal.bl.livrableIntitule
                                        ? currentBonLivraisonInModal.bl.livrableIntitule
                                        : `Livrable n°${currentBonLivraisonInModal.index + 1}`}
                              </>
                         }
                         handleCloseModal={() => setCurrentBonLivraisonInModal(undefined)}
                         modalSize={"xl"}
                    />
               )}

               {editBonLivraisonInModal && (
                    <MyModal
                         title={
                              <>
                                   Bon de livraison du {editBonLivraisonInModal.dateDebut?.format("D MMM YYYY")} au {editBonLivraisonInModal.dateFin?.format("D MMM YYYY")}
                              </>
                         }
                         show={true}
                         onCloseCallback={() => setEditBonLivraisonInModal(undefined)}
                         size={"xl"}
                    >
                         {ptf_type === "TYPE_ASSISTANCE_TECHNIQUE" ? (
                              <PtfPeriodeBonCommandeBonLivraisonEditForm bl={editBonLivraisonInModal} handleSubmitCallback={handleSubmitEditBonCommandeCallback} />
                         ) : (
                              <PtfPeriodeBonCommandeLivrableEditForm bl={editBonLivraisonInModal} handleSubmitCallback={handleSubmitEditBonCommandeCallback} />
                         )}
                    </MyModal>
               )}
          </div>
     )
}

interface IPtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommandePropsModel {
     bonCommande: IClientBonCommandeModel
     ptf_type: "TYPE_FORFAIT" | "TYPE_ASSISTANCE_TECHNIQUE" | string
}

export default PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsLivraison
